import {isNullOrUndef} from "chart.js/helpers";
// import I18n from 'i18n-js';
// I18n.locale = window.I18n.locale;
function checkBatterySearch(setBattery = false) {
    const newRecord = isNullOrUndef($('#warranty_id'))
    console.log('checkBatterySearch')
    console.log('setBattery = '+setBattery)
    console.log('newRecord = ' + newRecord)
    let battery_group       = $('#battery_group_id').val()
    let battery_brand       = $('#battery_brand_id').val()
    let battery_bci         = $('#battery_bci_id').val()
    let battery_condition   = $('#battery_condition_id').val()
    let batterySearch = { group_id: battery_group, brand_id: battery_brand,
        bci_id: battery_bci , condition_id: battery_condition }
    let params = { battery_search: batterySearch }
    if(newRecord === false) {
        params['id'] = $('#warranty_battery_id').val()
    }
    console.log(params,'params')
    // let params = { group_id: battery_group, brand_id: battery_brand, bci_id: battery_bci , condition_id: battery_condition }
    $.get('/search/batteries', params)
        .done(function(data) {
            cgreen(data.batteries, 'data.batteries')
            displayBatteryList(data,setBattery)
            if(setBattery) {
                ccyan($('#battery_model_id').val(), "$('#battery_model_id').val()")
                data.batteries.find(b => ccyan(b.model_id, 'b.model_id'))
                let battery = data.batteries.find(b => String(b.model_id) === $('#battery_model_id').val())
                let container = document.getElementById('battery-search-container')
                undefinedOrNull(battery) || selectBattery(battery, container, data)
            } else {
                $('#warranty_battery_id').val(null)
            }
        })
        .fail(function(jqXHR, textStatus, errorThrown) {

            console.error("Request failed:", textStatus);
            console.error("Error details:", errorThrown);
            console.log("HTTP Status Code:", jqXHR.status);
            console.log("Server Response:", jqXHR.responseText);
        });

}
function initTable(description, interactive = true, columnExtra = false) {
    // Create the horizontal rules
    const hrTop = document.createElement('hr');
    const hrBottom = document.createElement('hr');
    hrTop.classList.add('table-divider');
    hrBottom.classList.add('table-divider');
    // Sección principal
    const mainSection = document.createElement('div');
    mainSection.id = 'dynamic-battery-section'; // ID para ocultar
    // Crear la sub-sección para la tabla y el encabezado
    const subSection = document.createElement('div');
    subSection.className = 'm-section__sub';

    // Crear el encabezado de la tabla (info de cantidad y texto)
    const headerRowDiv = document.createElement('div');
    headerRowDiv.className = 'row m-section__sub';
    headerRowDiv.style.display = 'flex';
    headerRowDiv.innerHTML = `
        <div class="col-12">
            <h4>${description}</h4>
        </div>
    `;
    subSection.appendChild(headerRowDiv);

    // Crear la tabla
    const table = document.createElement('table');
    table.className = 'table m-table m-table--head-separator-brand table-custom';
    if(interactive === true) {
        table.classList.add('interactive-table');
    }
    let colExtra = ''
    if(columnExtra && isNullOrUndef($('#warranty_id'))) {
        colExtra = '<th>Cancelar</th>'
    }
    const thead = document.createElement('thead');
    let cantidad = interactive ? '<th>Cantidad</th>' : ''
    thead.innerHTML = `
        <tr>
            `+cantidad+`
            <th>BCI</th>
            <th>Marca</th>
            <th>Modelo</th>
            <th>Grupo</th>
            <th>Condición</th>
            <th>Precio lista</th>
            <th>Precio lista IVA</th>
            <th>Meses garantía</th>
            <th>Meses garantía flotilla</th>
            `+colExtra+`
        </tr>
    `;
    table.appendChild(thead);
    const tbody = document.createElement('tbody');
    return { table: table, mainSection: mainSection, subSection: subSection,
             headerRowDiv: headerRowDiv, thead: thead, tbody: tbody, hrTop: hrTop, hrBottom: hrBottom }
}
function createSelectedRow(battery, data) {
    const td = document.createElement('td');
    const inputId = $('#warranty_id')
    if( isNullOrUndef(inputId) || isNullOrUndef(inputId.val()) || inputId.val() === '' ) {
        td.innerHTML = `<a class="red-cross">✕</a>`
        td.addEventListener('click', () => {
            // displayBatteryList(data)
            deselectBattery(data);
        });
    }
    const selectedRow = document.createElement('tr');
    selectedRow.className = 'selected-row';
    selectedRow.innerHTML = `
                <td>${battery.bci}</td>
                <td>${battery.brand}</td>
                <td>${battery.model}</td>
                <td>${battery.group}</td>
                <td>${battery.condition}</td>
                <td>${battery.list_price_currency}</td>
                <td>${battery.list_price_iva_currency}</td>
                <td>${battery.model_warranty}</td>
                <td>${battery.model_warranty_fleet}</td>
            `;
    selectedRow.appendChild(td)
    return selectedRow
}
function selectBattery(battery, container, data) {
    cred( battery.brand, 'battery.brand')
    const table = initTable('Batería seleccionada:', false, true)
    const selectedRow = createSelectedRow(battery, data);
    // if($('#warranty_fleet') && $('#warranty_fleet').val() === '1') {
    //     $('#warranty_warranty').val(battery.model_warranty_fleet)
    // } else {
    //     $('#warranty_warranty').val(battery.model_warranty)
    // }
    // $('#warranty_battery_id').val(battery.id)
    $('#battery_model_id').val(battery.model_id)
    $('#warranty_price').val(battery.list_price_iva)
    $('#model_warranty_fleet').val(battery.model_warranty_fleet)
    $('#model_warranty').val(battery.model_warranty)
    $('#battery_condition_id').val(battery.condition_id).trigger('change');
    $('#battery_group_id').val(battery.group_id).trigger('change');
    $('#battery_brand_id').val(battery.brand_id).trigger('change');
    $('#battery_bci_id').val(battery.bci_id).trigger('change');
    setWarranty()

    container.innerHTML = '';
    container.style.display = 'block'; // Asegurarse que esté visible si se ocultó antes
    table.tbody.appendChild(selectedRow);
    table.table.appendChild(table.tbody);
    table.subSection.appendChild(table.table);
    table.mainSection.appendChild(table.hrTop)
    table.mainSection.appendChild(table.subSection); // Añade la subsección (con tabla) a la sección principal
    table.mainSection.appendChild(table.hrBottom)
    container.appendChild(table.mainSection); // Añade la sección principal al contenedor
}


function checkVehicleSearch(setVehicle = false) {
    // These hidden fields hold the values to re-select after a form error.
    const yearId = $('#vehicle_vehicles_years_id').val();
    const makeId = $('#make_id').val();
    const modelId = $('#model_id').val();
    const engineId = $('#engine_id').val();
    // cgreent('checkVehicleSearch')
    // cgreen(yearId, 'yearId')
    // cgreen(makeId, 'makeId')
    // cgreen(modelId, 'modelId')
    // cgreen(engineId, 'engineId')
    // Check if there's a year selected to start the process
    if (yearId) {
        getVehicleMakes()
            .then(function() {
                return getVehicleModels(); // Return the promise to continue the chain
            })
            .then(function() {
                return getVehicleEngines(setVehicle); // Return the promise
            })
    }
}
function getVehicleMakes() {
    $('#vehicle_vehicles_models_id').empty();
    $('#vehicle_vehicles_engines_id').empty();
    document.getElementById('bci-recomendado').innerHTML = ''
    let path = '/get/vehicle/makes/'+$('#vehicle_vehicles_years_id').val()
    return getVehicles('makes', 'vehicle_vehicles_years_id', 'vehicle_vehicles_makes_id', path, $('#make_id').val())
}

function getVehicleModels() {
    $('#vehicle_vehicles_engines_id').empty();
    document.getElementById('bci-recomendado').innerHTML = ''
    let path = '/get/vehicle/models/'+$('#vehicle_vehicles_years_id').val()+'/'+$('#vehicle_vehicles_makes_id').val()
    return getVehicles('models', 'vehicle_vehicles_makes_id', 'vehicle_vehicles_models_id', path, $('#model_id').val())
}

function getVehicleEngines(setVehicle = false) {
    let child = 'vehicle_vehicles_engines_id'
    let target_val   = $('#vehicle_vehicles_models_id').val()
    $('#'+child).empty().append(new Option('Seleccione una opción', ''));
    if (!target_val) {
        return $.Deferred().resolve().promise();
    }
    let path = '/get/vehicle/engines/'+$('#vehicle_vehicles_years_id').val()+'/'+$('#vehicle_vehicles_makes_id').val()+'/'+$('#vehicle_vehicles_models_id').val()
    let selectId = $('#engine_id').val()
    return $.get(path, {})
        .done(function(data) {
            if(!isNullOrUndef(data) && (isNullOrUndef(data.error) || data.error === false || data.error === 'false')) {
                data['engines'].forEach(item => {
                    $('#'+child).append(new Option(item.name, item.id));
                })
                $('#data_products').val(JSON.stringify(data['products']))
                if(selectId && setVehicle) {
                    $('#'+child).val(selectId).trigger('change');
                    setVehicleProduct()
                }
            } else {
                console.error('Something goes wrong while getting engines')
            }
        })
        .fail(function(jqXHR, textStatus, errorThrown) {

            console.error("Request failed:", textStatus);
            console.error("Error details:", errorThrown);
            console.log("HTTP Status Code:", jqXHR.status);
            console.log("Server Response:", jqXHR.responseText);
        });
}
function getVehicles(name, target, child, path, selectId = null) {
    let target_val   = $('#'+target).val()
    $('#'+child).empty().append(new Option('Seleccione una opción', ''));
    if (!target_val) {
        // Return a resolved promise so the .then() chain doesn't break
        return $.Deferred().resolve().promise();
    }
    return $.get(path, {})
        .done(function(data) {
            if(!isNullOrUndef(data) && (isNullOrUndef(data.error) || data.error === false || data.error === 'false')) {
                data[name].forEach(item => {
                    $('#'+child).append(new Option(item.name, item.id));
                });
                if(selectId) {
                    $('#'+child).val(selectId).trigger('change');
                }
            } else {
                console.error('Something goes wrong while getting '+name)
            }
        })
        .fail(function(jqXHR, textStatus, errorThrown) {

            console.error("Request failed:", textStatus);
            console.error("Error details:", errorThrown);
            console.log("HTTP Status Code:", jqXHR.status);
            console.log("Server Response:", jqXHR.responseText);
        });
}

function setVehicleProduct() {
    let engine_id = $('#vehicle_vehicles_engines_id').val()
    let str_products   = $('#data_products').val()
    let products = JSON.parse(str_products)
    let target = document.getElementById('bci-recomendado')
    const result = products.find(
        product => product.engine_id === Number(engine_id)
    );
    let bcis_array = result?.bcis_array
    let bcis = result?.bcis
    target.innerHTML = isNullOrUndef(bcis) ? '' : 'BCI: ' + result?.bcis
    if(bcis_array && bcis_array[0]) {
        $('#battery_group_id').val(null)
        $('#battery_brand_id').val(null)
        $('#battery_bci_id').val(null)
        $('#battery_condition_id').val(null)
        let foundValue = null;
        $('#battery_bci_id option').each(function() {
            if ($(this).text() === bcis_array[0]) {
                foundValue = $(this).val();
                return false;
            }
        });
        if (foundValue) {
            $('#battery_bci_id').val(foundValue).trigger('change.select2');
            console.log("Selected option with text '" + bcis_array[0] + "' using value: " + foundValue);
        } else {
            console.log("No option found with text: " + bcis_array[0]);
        }
        checkBatterySearch()
    }
}
    function deselectBattery(data) {
    $('#battery_model_id').val(null)
    $('#warranty_battery_id').val(null)
    $('#warranty_warranty').val(null)
    $('#warranty_price').val(null)
    $('#model_warranty_fleet').val(null)
    $('#model_warranty').val(null)
    displayBatteryList(data)
}
function displayBatteryList(data, setBattery = false) {
    cgreen(data.batteries, 'data.batteries')
    const container = document.getElementById('battery-search-container');
    if (!container) {
        console.error("Missing container.");
        return;
    } else if (!data || !data.batteries) {
        console.error("Missing data.");
        return;
    }
    container.innerHTML = '';
    container.style.display = 'block';
    const batteries = data.batteries;
    if (!setBattery && (!batteries || batteries.length === 0)) {
        const noResultsDiv = document.createElement('div');
        noResultsDiv.className = 'm-section__content';
        noResultsDiv.innerHTML = '<hr class="table-divider"><p class="no-results text-centered">No se encontraron Baterías</p><hr class="table-divider">';
        container.appendChild(noResultsDiv);
        return;
    }
    const table = initTable('Seleccione una batería:')
    batteries.forEach(battery => {
        const tr = document.createElement('tr');
        tr.className = 'tr-custom';

        tr.innerHTML = `
            <td>${battery.cantidad}</td>
            <td>${battery.bci}</td>
            <td>${battery.brand}</td>
            <td>${battery.model}</td>
            <td>${battery.group}</td>
            <td>${battery.condition}</td>
            <td>${battery.list_price_currency}</td>
            <td>${battery.list_price_iva_currency}</td>
            <td>${battery.model_warranty}</td>
            <td>${battery.model_warranty_fleet}</td>
        `;
        // Acción al hacer click en la fila
        tr.addEventListener('click', () => {
            credt( battery, 'battery')
            credt( battery.brand, 'battery.brand')
            selectBattery(battery, container, data);
        });
        table.tbody.appendChild(tr);
    });
    table.table.appendChild(table.tbody);
    table.subSection.appendChild(table.table);
    table.mainSection.appendChild(table.hrTop)
    table.mainSection.appendChild(table.subSection); // Añade la subsección (con tabla) a la sección principal
    table.mainSection.appendChild(table.hrBottom)
    container.appendChild(table.mainSection); // Añade la sección principal al contenedor
}

function setWarranty() {
    let checked = $('#warranty_fleet') && $('#warranty_fleet').prop('checked')
    if(checked) {
        $('#warranty_warranty').val($('#model_warranty_fleet').val())
    } else {
        $('#warranty_warranty').val($('#model_warranty').val())
    }
}

/**
 * Unbinds the 'select2:select' event from one or more Select2 elements.
 *
 * @param {...string} select_ids - A comma-separated list of element IDs (without the #).
 */
function clearSelect2(...select_ids) {
    if (select_ids.length === 0) {
        return;
    }
    // Build a single jQuery selector for all IDs.
    const selector = select_ids.map(id => '#' + id).join(', ');
    // Use the combined selector to turn off the event for all matched elements.
    $(selector).off('select2:select');
}
const select2Ids = ['battery_group_id','battery_brand_id','battery_bci_id','battery_condition_id','vehicle_vehicles_years_id','vehicle_vehicles_makes_id','vehicle_vehicles_models_id','vehicle_vehicles_engines_id']
function setupWarrantiesForm() {
    const form = document.getElementById("warranties_form");
    if (form) {
        console.log('warranties turbolinks loaded.')
        // Clear previous listeners
        // clearSelect2('battery_group_id','battery_brand_id','battery_bci_id','battery_condition_id')
        // clearSelect2('vehicle_vehicles_years_id','vehicle_vehicles_makes_id','vehicle_vehicles_models_id','vehicle_vehicles_engines_id')
        clearSelect2(...select2Ids)
        // Init search select inputs
        checkBatterySearch(true)
        checkVehicleSearch(true)
        // Attach new listeners
        $(document)
            .on('select2:select', '#battery_group_id', checkBatterySearch)
            .on('select2:select', '#battery_brand_id', checkBatterySearch)
            .on('select2:select', '#battery_bci_id', checkBatterySearch)
            .on('select2:select', '#battery_condition_id', checkBatterySearch)
            .on('select2:select', '#vehicle_vehicles_years_id', getVehicleMakes)
            .on('select2:select', '#vehicle_vehicles_makes_id', getVehicleModels)
            .on('select2:select', '#vehicle_vehicles_models_id', getVehicleEngines)
            .on('select2:select', '#vehicle_vehicles_engines_id', setVehicleProduct)
            .on('change', '#warranty_phone_number', getCustomer)
            .on('change', '#warranty_fleet', setWarranty)
    }
}

function getCustomer()  {
    let phone_number = $('#warranty_phone_number').val()
    if (!phone_number || phone_number.length < 10) {
        return $.Deferred().resolve().promise();
    }
    $('#warranty_first_name').val()
    $('#warranty_last_name').val()
    $('#warranty_email').val()
    let path = '/search/customer/' + $('#warranty_phone_number').val()
    return $.get(path, {})
        .done(function(data) {
            if(!isNullOrUndef(data) && (isNullOrUndef(data.error) || data.error === false || data.error === 'false')) {
                if (data.customer) {
                    $('#warranty_phone_number').val(phone_number)
                    $('#warranty_first_name').val(data.customer.first_name)
                    $('#warranty_last_name').val(data.customer.last_name)
                    $('#warranty_email').val(data.customer.email)
                }
            } else {
                console.error('Something goes wrong while getting '+phone_number)
            }
        })
        .fail(function(jqXHR, textStatus, errorThrown) {
            console.error("Request failed:", textStatus);
            console.error("Error details:", errorThrown);
            console.log("HTTP Status Code:", jqXHR.status);
            console.log("Server Response:", jqXHR.responseText);
        });

}

function destroyWarrantiesForm() {
    const form = document.getElementById("warranties_form");
    if (form) {
        console.log("Cleanup warranties_form...")
        document.removeEventListener("turbolinks:load", setupWarrantiesForm);
        document.removeEventListener('turbolinks:before-cache', destroyWarrantiesForm)

        $(document)
            .off('select2:select', '#battery_group_id', checkBatterySearch)
            .off('select2:select', '#battery_brand_id', checkBatterySearch)
            .off('select2:select', '#battery_bci_id', checkBatterySearch)
            .off('select2:select', '#battery_condition_id', checkBatterySearch)
            .off('select2:select', '#vehicle_vehicles_years_id', getVehicleMakes)
            .off('select2:select', '#vehicle_vehicles_makes_id', getVehicleModels)
            .off('select2:select', '#vehicle_vehicles_models_id', getVehicleEngines)
            .off('select2:select', '#vehicle_vehicles_engines_id', setVehicleProduct)
            .off('change', '#warranty_phone_number', getCustomer)

        // // clearSelect2(...select2Ids)
        // select2Ids.forEach((selector, index) => {
        //     console.log('woop')
        //     console.log(selector)
        //     console.log(this)
        //     console.log($(this))
        //     if ($(this).data('select2')) {
        //         $(this).select2('destroy');
        //     }
        // });

        // $('.selectpicker').each(function() {
        //     console.log('woop')
        //     if ($(this).data('select2')) {
        //         $(this).select2('destroy');
        //     }
        // });
    }
}
document.addEventListener("turbolinks:load", setupWarrantiesForm);
// document.addEventListener('turbolinks:before-cache', destroyWarrantiesForm);
window.addEventListener('beforeunload', (event) => {
    destroyWarrantiesForm();
});

window.checkBatterySearch = checkBatterySearch;
window.displayBatteryList = displayBatteryList;
window.checkVehicleSearch = checkVehicleSearch;
window.getVehicleMakes = getVehicleMakes;
window.getVehicleModels = getVehicleModels;
window.getVehicleEngines = getVehicleEngines;
window.setVehicleProduct = setVehicleProduct;
